import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import {
  CancellationInsights,
  CancellationInsightsFilter,
  CancellationResponseDetail,
  CancellationResponses,
  CancellationResponsesFilter,
} from '../cancellations.types';

/**
 * Reads the exit-survey reporting endpoints.
 *
 * Every route is GodMode-gated server-side. The tab itself is not hidden, so a
 * 403 here is an expected response rather than a fault — the dashboard renders
 * an access panel for it. Note `auth.interceptor` retries a 403 once after
 * syncing claims, so the error only surfaces after that retry fails.
 */
@Injectable({ providedIn: 'root' })
export class AdminCancellationsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.shout_api.url}/subscription-offboarding/admin`;

  getInsights(filter: CancellationInsightsFilter): Observable<CancellationInsights> {
    return this.http.post<CancellationInsights>(`${this.baseUrl}/insights`, filter);
  }

  listResponses(filter: CancellationResponsesFilter): Observable<CancellationResponses> {
    return this.http.post<CancellationResponses>(`${this.baseUrl}/responses`, filter);
  }

  getResponse(id: string): Observable<CancellationResponseDetail> {
    return this.http.get<CancellationResponseDetail>(`${this.baseUrl}/responses/${id}`);
  }
}
